import React from "react";
import { LongballLogo } from "../components/longball-logo/longball-logo";
import { BLACK, GRAY, GREEN, MLB_TEAM_LOGO } from "../player-report/constants";
import { Footer } from "../player-report/footer";

const BrandLockup = () => (
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <LongballLogo scale={0.4} />
    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
      <div style={{ color: BLACK, fontWeight: 900, fontSize: 15, letterSpacing: 0.5, fontFamily: "'Arial Black', Arial, sans-serif" }}>
        LONGBALL
      </div>
      <div style={{ color: GREEN, fontWeight: 800, fontSize: 11, letterSpacing: 3.5, marginTop: 3, fontFamily: "Arial, sans-serif" }}>
        LABS
      </div>
    </div>
  </div>
);

const ImprovementTable = ({ title, rows, valueLabel }) => (
  <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", display: "flex", flexDirection: "column" }}>
    <div style={{ background: GREEN, padding: "10px 14px" }}>
      <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 8, textTransform: "uppercase", letterSpacing: 1.5, fontFamily: "Arial, sans-serif", marginBottom: 2 }}>
        Most Improved
      </div>
      <div style={{ color: "#ffffff", fontWeight: 900, fontSize: 12, letterSpacing: -0.2 }}>{title}</div>
    </div>
    <div style={{ padding: "8px 0" }}>
      {rows.map((row, i) => (
        <div key={row.name} style={{
          display: "flex",
          alignItems: "center",
          padding: "7px 14px",
          borderBottom: i < rows.length - 1 ? "1px solid #e2e8f0" : "none",
          gap: 10,
        }}>
          <div style={{ color: "rgba(0,0,0,0.25)", fontWeight: 900, fontSize: 11, fontFamily: "Arial, sans-serif", width: 16, textAlign: "right", flexShrink: 0 }}>
            {i + 1}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ color: BLACK, fontWeight: 700, fontSize: 11, fontFamily: "Arial, sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {row.name}
            </div>
            <div style={{ color: "rgba(0,0,0,0.35)", fontSize: 9, fontFamily: "Arial, sans-serif", marginTop: 1 }}>
              {row.sub}
            </div>
          </div>
          <div style={{ color: GREEN, fontWeight: 900, fontSize: 13, fontFamily: "'Arial Black', Arial, sans-serif", flexShrink: 0 }}>
            {valueLabel(row)}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const TeamReportPage2 = (props) => {
  const { data } = props;

  const players = data.players ?? [];

  const byWar = [...players]
    .filter((p) => p.warGain != null)
    .sort((a, b) => (b.warGain ?? 0) - (a.warGain ?? 0))
    .slice(0, 12)
    .map((p) => ({ ...p, sub: `${p.actualHR ?? "—"} HR → ${p.projExpected ?? "—"} HR` }));

  const byValue = [...players]
    .filter((p) => p.moneyGained != null)
    .sort((a, b) => (b.moneyGained ?? 0) - (a.moneyGained ?? 0))
    .slice(0, 12)
    .map((p) => ({ ...p, sub: `+${p.warGain != null ? p.warGain.toFixed(2) : "—"} WAR` }));

  const byHR = [...players]
    .filter((p) => p.projExpected != null && p.actualHR != null)
    .sort((a, b) => ((b.projExpected ?? 0) - (b.actualHR ?? 0)) - ((a.projExpected ?? 0) - (a.actualHR ?? 0)))
    .slice(0, 12)
    .map((p) => ({ ...p, sub: `${p.actualHR} HR current` }));

  return (
    <div style={{ width: 900, height: 900, position: "relative", overflow: "hidden", background: "#ffffff", fontFamily: "'Arial Black', Arial, sans-serif", display: "flex", flexDirection: "column" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 5, background: GREEN }} />

      <div style={{ padding: "24px 32px 0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <BrandLockup />
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 9, textTransform: "uppercase", letterSpacing: 2, fontFamily: "Arial, sans-serif" }}>
              Players Most Improved
            </div>
            <div style={{ color: BLACK, fontWeight: 900, fontSize: 18, lineHeight: 1, letterSpacing: -0.5, marginTop: 2 }}>{data.teamName}</div>
            <div style={{ color: "rgba(0,0,0,0.4)", fontSize: 10, fontFamily: "Arial, sans-serif", marginTop: 2 }}>
              {data.teamAbbr} · {data.season} Season
            </div>
          </div>
          {data.teamId && (
            <img
              src={MLB_TEAM_LOGO(data.teamId)}
              alt={data.teamAbbr}
              style={{ width: 54, height: 54, objectFit: "contain" }}
            />
          )}
        </div>
      </div>

      <div style={{ margin: "16px 32px", height: 1, background: GRAY }} />

      <div style={{ padding: "0 32px", flex: 1, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, minHeight: 0 }}>
        <ImprovementTable
          title="WAR Improvement"
          rows={byWar}
          valueLabel={(p) => `+${p.warGain.toFixed(2)} WAR`}
        />
        <ImprovementTable
          title="Value Added"
          rows={byValue}
          valueLabel={(p) => `$${p.moneyGained.toFixed(1)}M`}
        />
        <ImprovementTable
          title="Home Runs Added"
          rows={byHR}
          valueLabel={(p) => `+${(p.projExpected - p.actualHR)} HR`}
        />
      </div>

      <div style={{ padding: "12px 32px 0" }} />

      <Footer name={data.teamName} season={data.season} />
    </div>
  );
};
